<template>
  <div class="container-flight margin_container_hf">
    <div class="wrapper">
      <div class="landing-page">
        <div style="text-align: center" class="icon__download">
          <img
            style="width: 64%; margin-bottom: 22px; height: auto"
            src="../../../public/img/tour_error.png"
            alt=""
          />
        </div>

        <h1>{{ responseLabel }}</h1>

        <p>با پشتیبانی تماس بگیرید</p>
        <button @click="gotoHome()" class="button_error">بازگشت به صفحه اصلی</button>
      </div>
    </div>
  </div>
</template>


<script>
import Store from "./store/index";
require("linqjs");

export default {
  store: Store,

  components: {},
  data() {
    return {
      responseId: Number,
      responseLabel: "خطا در رزرو",
      params: {},
      tickets: [],
      roomDetails: [],
      passengers: [],
      flightTickets: [],
      ticketActionModel: {},
    };
  },
  created() {
    this.params = this.$route.query;
    this.responseId = Number(this.params.id);

    if (this.responseId < 1) {
      if (this.responseId === -3) {
        this.responseLabel = "خطا در پرداخت";
      } else if (this.responseId === -2) {
        this.responseLabel = " خطا در رزرو هتل";
      } else if (this.responseId === -1) {
        this.responseLabel = " خطا در رزرو پرواز";
      }
    }

    if (this.responseId === 17) {
       this.responseLabel = "انصراف از پرداخت";
    }

    this.getTicket(this.params.id);
  },
  computed: {},
  methods: {
       gotoHome() {
      if (this.$route.name != "main home") this.$router.push("/");
    },
    getAirLineLogoUrl(name) {
      return "../img/airlines/" + name + ".png";
    },
    async getTicket(reserveNumber) {
      var ticketReq = {
        reserveNumber: reserveNumber,
      };

      var res = await this.$store.dispatch("Book/GetTicket", ticketReq);
      if (res) {
        if (res != null) {
          this.tickets = res.ticketModels;
          this.roomDetails = res.ticketModels.reduce(
            (results, item) =>
              results.find((i) => i.roomDetailId === item.roomDetailId)
                ? results
                : [...results, item],
            []
          );

          this.passengers = res.ticketModels.reduce(
            (results, item) =>
              results.find((i) => i.pasportId === item.pasportId)
                ? results
                : [...results, item],
            []
          );

          this.flightTickets = res.ticketModels.reduce(
            (results, item) =>
              results.find((i) => i.ticketNumber === item.ticketNumber)
                ? results
                : [...results, item],
            []
          );

          this.ticketActionModel = {
            tickets: this.tickets,
            roomDetails: this.roomDetails,
            passengers: this.passengers,
            flightTickets: this.flightTickets,
          };
        } else {
          console.log("Failed");
        }
      }
    },
  },
  mounted() {},
};
</script>
<style scoped>
#action a {
  width: 140px;
}
.voucher_detail {
  display: grid;
  text-align: initial;
  font-size: 15px;
}

.voucher_detail time {
  display: flex;
}
.voucher_detail label {
  text-align: initial;
}
.package-time {
  text-align: initial;
}
.package-time label {
  margin-left: 10px;
  font-size: 15px;
}
.package-time label strong {
  color: rgb(73, 72, 72);
}
.table tbody tr td {
  text-align: initial;
}
.airlines_logo {
  width: 30px;
  height: 30px;
}
.room_details {
  width: 90% !important;
  margin: 25px auto auto auto;
}

.room_details table tbody tr td {
  text-align: center;
}

.wrapper {
  max-width: 960px;
  width: 100%;
  margin: 30px auto;
  transform: scale(0.8);
}
.landing-page {
  max-width: 960px;
  height: 490px;
  margin: 0;
  box-shadow: 0px 0px 8px 1px #ccc;
  background: #fafafa;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
svg {
  width: 50%;
  max-height: 225px;
  height: auto;
  margin: 0 0 15px;
}
h1 {
  font-size: 30px;
  margin: 0;
}
p {
  font-size: 16px;
  width: 35%;
  margin: 16px auto 24px;
  text-align: center;
}
.button_error {
    width: 200px;
    border-radius: 50px;
    padding: 8px 24px;
    font-size: 16px;
    cursor: pointer;
    background: #177bff;
    color: #fff;
    border: none;
    box-shadow: 0 4px 8px 0 #ccc;
        width: 200px;
}
</style>